/* *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 *
 * Copyright 2025 - Koninklijk Nederlands Meteorologisch Instituut (KNMI)
 * Copyright 2025 - Finnish Meteorological Institute (FMI)
 * Copyright 2025 - The Norwegian Meteorological Institute (MET Norway)
 * */

import React from 'react';
import { useSelector } from 'react-redux';
import {
  genericSelectors,
  mapSelectors,
  uiSelectors,
  uiTypes,
  useSetupDialog,
} from '@opengeoweb/store';
import { LocationInfo } from './LocationInfo';
import { timeSeriesSelectors } from '../../../store';
import type { TimeSeriesRootState } from '../../../store/types';

export const LocationInfoConnect: React.FC = () => {
  const panelId = useSelector((store: TimeSeriesRootState) =>
    uiSelectors.getSourcePanelId(
      store,
      uiTypes.DialogTypes.TimeSeriesLocationInfo,
    ),
  );
  const services = useSelector((state: TimeSeriesRootState) =>
    timeSeriesSelectors.getServices(state),
  );

  const selectedMapIds = useSelector((state: TimeSeriesRootState) =>
    genericSelectors.getLinkedMaps(state, panelId),
  );

  const selectedFeature = useSelector((state: TimeSeriesRootState) =>
    genericSelectors.getSelectedFeatureAsGeoJSON(state.syncGroups!, panelId),
  );

  const mapPinLocation = useSelector((store: TimeSeriesRootState) =>
    mapSelectors.getPinLocation(store, selectedMapIds[0]),
  );

  const DIALOG_TYPE = uiTypes.DialogTypes.TimeSeriesLocationInfo;

  const { setDialogOrder, dialogOrder, isDialogOpen, onCloseDialog } =
    useSetupDialog(DIALOG_TYPE);

  return (
    <LocationInfo
      feature={selectedFeature}
      isOpen={isDialogOpen}
      mapPinLocation={mapPinLocation}
      onClose={onCloseDialog}
      onMouseDown={setDialogOrder}
      order={dialogOrder}
      services={services}
    />
  );
};
